var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-viz"},[_c('Box',{ref:"box",staticClass:"box",style:({
      position: 'absolute',
      width: _vm.coords[_vm.getCountryId].artBoard.width * _vm.scaleFactor + 'px',
      height: _vm.coords[_vm.getCountryId].artBoard.height * _vm.scaleFactor + 'px',

      top: ((_vm.boxTranslate.y -
        (_vm.coords[_vm.getCountryId].artBoard.height * _vm.scaleFactor) / 2 +
        _vm.viewPortMinDimensions.height / 2) + "px "),
      left: ((_vm.boxTranslate.x -
        (_vm.coords[_vm.getCountryId].artBoard.width * _vm.scaleFactor) / 2 +
        _vm.viewPortMinDimensions.width / 2) + "px "),
      transition: ("all " + (_vm.panActive ? _vm.panDuration / 1000 : 0) + "s ease")
    }),attrs:{"dragBounds":_vm.dragBounds},on:{"drag-start":_vm.setMouseCoord,"drag-end":_vm.dragEnd}},[_c('div',{staticClass:"paintings-container",style:({
        transform: ("scale(" + _vm.scaleFactor + ")")
      }),on:{"click":_vm.deselectMuseum}},_vm._l((_vm.paintings),function(paint){return _c('CanvasImage',{key:paint.id,staticClass:"paint-box",style:({
          width: _vm.findCoord(paint.id).width + 'px',
          height: _vm.findCoord(paint.id).height + 'px',
          left: _vm.findCoord(paint.id).x + 'px',
          top: _vm.findCoord(paint.id).y + 'px',
          opacity: _vm.getMuseum === null || paint.museum === _vm.getMuseum ? 1 : 0.2,
          pointerEvents:
            _vm.getMuseum === null || paint.museum === _vm.getMuseum ? 'all' : 'none',
          cursor:
            _vm.getMuseum === null || paint.museum === _vm.getMuseum
              ? 'pointer'
              : 'initial'
        }),attrs:{"paint":paint},on:{"click":function($event){return _vm.canvasSetPaint(paint, $event)}}})}),1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }